import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class ContactUsService {
    constructor(
        private http: HttpClient,
    ){}

    send(message: string): Observable<{ result: string }> {
        return this.http.post<{result: string}>('/api/contact-us', {message: message});
    }
}

